import { Image, Text, VStack, chakra } from "@chakra-ui/react";
import { RatioType } from "common/interfaces/KYDMarketing";

const Video = chakra("video");

// Helper function to determine if a URL is a video
const isVideoUrl = (url: string): boolean => {
  if (!url) return false;
  const videoExtensions = [".mp4", ".webm", ".ogg", ".mov", ".avi", ".mkv"];
  const lowerUrl = url.toLowerCase();
  return videoExtensions.some((ext) => lowerUrl.includes(ext));
};

interface CreativeImageProps {
  src: string;
  type?: RatioType;
  width?: number;
  height?: number;
  isVideo?: boolean;
}

const CreativeImage = ({
  src,
  type,
  width = 200,
  height = 200,
  isVideo = false,
}: CreativeImageProps) => {
  const isVideoMedia = isVideo || isVideoUrl(src);

  return (
    <VStack>
      {isVideoMedia ? (
        <Video
          aspectRatio={type === RatioType.square ? 1 : 9 / 16}
          h={`${height}px`}
          minH={`${height}px`}
          bg="gray.200"
          objectFit="cover"
          borderRadius="md"
          src={src}
          border="1px solid #E0E0E0"
          controls
          autoPlay
          muted
          loop
        />
      ) : (
        <Image
          // w={`${width}px`}
          aspectRatio={type === RatioType.square ? 1 : 9 / 16}
          h={`${height}px`}
          minH={`${height}px`}
          // minH
          bg="gray.200"
          objectFit="cover"
          borderRadius="md"
          src={src}
          alt={src}
          border="1px solid #E0E0E0"
        />
      )}
      <Text fontSize="sm" color="gray.500" w="full" textAlign="left">
        {type || (isVideoMedia ? "Video" : "Image")}
      </Text>
    </VStack>
  );
};

export default CreativeImage;
